
import { Link } from 'react-router-dom';
import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface TreatmentServiceCardProps {
  title: string;
  link?: string;
  description?: string;
  imageUrl?: string;
  icon?: ReactNode;
  iconImage?: string;
  iconAlt?: string;
  iconType?: string;
  backgroundColor?: string;
  textColor?: string;
}

export const TreatmentServiceCard = ({ 
  title, 
  link, 
  description, 
  imageUrl,
  iconImage,
  iconAlt,
  backgroundColor = 'bg-dental-cream',
  textColor = 'text-dental-text'
}: TreatmentServiceCardProps) => {
  
  return (
    <Link 
      to={link || '#'} 
      className={cn(
        `${backgroundColor} rounded-xl p-7 shadow-soft text-center transition-all duration-300 
        hover:shadow-lg hover:-translate-y-1 flex flex-col items-center`,
        textColor
      )}
    >
      {imageUrl && (
        <div className="w-16 h-16 mb-4 overflow-hidden">
          <img src={imageUrl} alt={title} className="w-full h-full object-contain" />
        </div>
      )}

      {iconImage && (
        <div className="w-16 h-16 mb-4 flex items-center justify-center">
          <img src={iconImage} alt={iconAlt || title} className="w-full h-full object-contain" />
        </div>
      )}
      
      <h3 className="text-lg font-medium mb-2">{title}</h3>
      {description && (
        <p className="mt-1 text-sm text-dental-muted">{description}</p>
      )}
    </Link>
  );
};
